<script>
	import {
		ChevronsRightIcon,
		PauseIcon,
		PlayIcon,
		RotateCcwIcon,
		LogInIcon,
	} from "svelte-feather-icons";
	import { getContext, onMount, onDestroy } from "svelte";
	import ReplayTimelineHandler from './replayTimeline'

	const flightContext = getContext("flight")
	let flight 
	let timelineHandler
	let store
	let liveServerStateStore

	$: isLive = $liveServerStateStore && $liveServerStateStore.eventWebSocket;

	let timelineBox;
	let timelineSelection;
	let tooltipElement;

	onMount(() => {
		flight = flightContext.get()
		store = flight.replayInfoStore
		liveServerStateStore = flight.liveServerStateStore
		timelineHandler = flight.getHandler(ReplayTimelineHandler)
	})
	onDestroy(() => {
		flight.releaseHandler(ReplayTimelineHandler)
	})
	function restartReplay() {
		flight.seekToTime(timelineHandler.percentToTime(0));
	}
	function pause() {
		flight.isReplayPaused = true;
	}
	function resume() {
		flight.isReplayPaused = false;
	}
	function goLive() {
		flight.goToLive()
	}

	function onTimelineClick(e) {
		if (flight.isGuest) return
		const bounds = timelineBox.getBoundingClientRect();
		const posX = e.clientX - bounds.left;
		let percent = posX / bounds.width;

		flight.seekToTime(timelineHandler.percentToTime(percent));
	}

	function onTimelineMouseMove(e) {
		const bounds = timelineBox.getBoundingClientRect();
		const posX = e.clientX - bounds.left;
		const percent = posX / bounds.width;
		if (percent >= 1 || percent < 0) return;

		const timestamp = timelineHandler.percentToTime(percent);

		tooltipElement.textContent = new Date(timestamp).toLocaleTimeString();
		const tooltipBounds = tooltipElement.getBoundingClientRect();
		tooltipElement.style.top = `${bounds.top - 5 - tooltipBounds.height}px`;
		tooltipElement.style.left = `${e.clientX - tooltipBounds.width / 2}px`;

		timelineSelection.style.left = `${
			e.layerX - timelineSelection.getBoundingClientRect().width / 2
		}px`;
	}
</script>

{#if $liveServerStateStore?.startedTime}
	<div id="replayTimeline">
		{#if !flight.isGuest}
		<div class="playPause">
			{#if $store.isPaused}
				<div on:click={resume}><PlayIcon /></div>
			{:else if $store.isFollowingHead && !isLive}
				<div on:click={restartReplay}><RotateCcwIcon /></div>
			{:else}
				<div on:click={pause}><PauseIcon /></div>
			{/if}
		</div>
		{/if}
		<div
			id="timelineBox"
			on:click={onTimelineClick}
			bind:this={timelineBox}
			on:mousemove={onTimelineMouseMove}
		>
			<div class="timelineTooltip" bind:this={tooltipElement} />
			<div class="background">
				<div
					class="timelinePlayed"
					style={`width: ${
						$store.isFollowingHead
							? 100
							: timelineHandler.timeToPercent($store.currentTimestamp, $store.currentLiveTimestamp) * 100
					}%;`}
				/>
				<slot />
				<div bind:this={timelineSelection} class="timelineSelection" />
			</div>
		</div>
		{#if !$store.isFollowingHead || $store.isPaused}
			<div class="liveContainer">
				<div on:click={goLive} class="gotoLive">
					{#if isLive}
						<ChevronsRightIcon />
					{:else}
						<LogInIcon/>
					{/if}
				</div>
			</div>
		{:else if isLive}
			<div class="liveContainer">
				<div class="liveConnection" />
			</div>	
		{/if}			
	</div>
{/if}

<style>
	#replayTimeline {
		color: white;
		display: flex;
		align-content: center;
		align-self: center;
		align-items: center;
		padding: 0 20px;
		border-radius: 12px;
		grid-row: 2;
		margin: 0 64px 32px 64px;
		pointer-events: auto;
		background: rgba(37, 37, 37, 0.9);
	}

	#replayTimeline .background {
		background: grey;
		border: black 1px solid;
		height: 8px;
		width: 100%;
		position: absolute;
	}

	.background > * {
		position: absolute;
	}

	#timelineBox:hover .timelineSelection {
		background: white;
	}

	#timelineBox:hover .timelineTooltip {
		display: block;
	}

	#timelineBox {
		flex: 1;
		padding: 25px 0;
		min-height: 8px;
		/* z-index: 1; */
		position: relative;
		box-sizing: content-box;
	}

	.timelineSelection {
		/* z-index: 2; */
		width: 4px;
		height: 100%;
		pointer-events: none;
	}

	.timelinePlayed {
		background: #cc0000;
		width: 100%;
		height: 100%;
		/* z-index: 3; */
	}

	.timelineTooltip {
		display: none;
		background: rgba(37, 37, 37, 0.9);
		color: white;
		border-radius: 12px;
		width: 12rem;
		position: fixed;
		top: -70px;
		text-align: center;
		padding: 12px;
	}

	.liveContainer {
		width: 24px;
	}

	.liveConnection {
		height: 15px;
		width: 15px;
		background-color: #cc0000;
		border-radius: 50%;
		/* margin-right:1rem; */
		margin-left: 8px;
	}

	.gotoLive {
		margin-left: 8px;
		cursor: pointer;
	}

	.playPause {
		width: 24px;
		height: 24px;
		margin-right: 8px;
		cursor: pointer;
	}

	@media only screen and (max-width: 600px) {
		#replayTimeline {
			grid-row: 3;
			grid-column: 1;
			width: 28rem;
			margin-left: 6rem;
		}
	}
</style>
